// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-section {
  background: #121212;
  color: #f1f1f1;
  padding: 0;
  min-height: 100vh;
  min-height: -webkit-fill-available; /* Fix untuk mobile Safari */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  /* width: 100%; */
  max-width: calc(100 * var(--vw));
  overflow-x: hidden;
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.form-heading-banner {
  width: 100%;
  max-width: 100%;
  padding: 60.95px 30.475px;
  margin-bottom: 0;
  display: flex;
  align-items: flex-start;
}

.heading-content {
  display: flex;
  flex-direction: column;
  gap: calc(0.5 * var(--vw));
  width: 100%;
  overflow: visible;
}

.heading-line {
  font: 500 normal calc(6 * var(--vw))/0.9 "Satoshi", sans-serif;
  letter-spacing: -0.05em;
  color: #f1f1f1;
  display: flex;
  align-items: center;
  gap: calc(0.5 * var(--vw));
  white-space: nowrap;
  overflow: visible;
  width: 100%;
}

.form-slide-heading-personal .heading-line {
  font-size: clamp(32px, calc(5.5 * var(--vw)), 80px);
}

.fire-emoji {
  font-size: calc(6 * var(--vw));
  line-height: 0.9;
  display: inline-block;
}

.contact-form {
  max-width: 900px;
  width: 100%;
}

/* Form Slide Styles - Slide by Slide Animation */
.form-slide {
  height: 100vh;
  height: -webkit-fill-available; /* Fix untuk mobile Safari */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: calc(100 * var(--vw));
  padding: calc(5 * var(--vw)) calc(5.5 * var(--vw));
  box-sizing: border-box;
}

.form-slide-heading-personal {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: calc(4 * var(--vw));
  padding: calc(5 * var(--vw)) calc(5.5 * var(--vw)) !important;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.form-slide-heading-personal .form-heading-banner {
  margin-bottom: 0 !important;
  width: 100%;
  max-width: 100%;
  padding: 60.95px 30.475px;
  margin-left: 0 !important;
  padding-left: 0 !important;
  box-sizing: border-box;
  overflow: visible;
}

.form-slide-heading-personal .form-heading-banner .heading-content {
  width: 100%;
  overflow: visible;
  padding: 0;
  margin: 0;
}

.form-slide-heading-personal .heading-line {
  padding: 0;
  margin: 0;
}

.form-slide-heading-personal .form-group {
  width: 100%;
  max-width: 100%;
  margin-bottom: 0;
  box-sizing: border-box;
}

.form-slide-heading-personal .form-group .form-text {
  max-width: 100%;
}

.form-slide-project-solution-submit {
  display: flex;
  align-items: center;
  justify-content: center;
}

.form-slide-personal .form-group,
.form-slide-project-solution-submit .form-group {
  margin-bottom: calc(4 * var(--vw));
  width: 100%;
  max-width: 900px;
}

.form-slide-project-solution-submit {
  flex-direction: column;
  gap: calc(2 * var(--vw));
}

/* Responsive adjustments for slide 2 */
@media (max-width: 768px) {
  .form-slide-project-solution-submit {
    gap: calc(4 * var(--vw));
  }

  .form-slide-project-solution-submit .form-group {
    margin-bottom: calc(5 * var(--vw));
  }
}

@media (max-width: 480px) {
  .form-slide-project-solution-submit {
    gap: calc(3.5 * var(--vw));
  }

  .form-slide-project-solution-submit .form-group {
    margin-bottom: calc(4 * var(--vw));
  }
}

.form-slide-project-solution-submit .form-submit-container {
  margin-top: 0;
}

.form-group {
  margin-bottom: calc(4 * var(--vw));
  width: 100%;
}

.form-slide-heading-personal .form-group {
  margin-bottom: 0;
}

.form-text {
  font: 500 normal calc(2.3 * var(--vw))/1.6 "Satoshi", sans-serif;
  letter-spacing: -0.03em;
  color: #f1f1f1;
  margin-bottom: calc(1.5 * var(--vw));
  max-width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.form-slide-heading-personal .form-text {
  max-width: 100%;
  line-height: 1.5;
  word-spacing: 0.05em;
}

.form-input.inline-input {
  border: none;
  border-bottom: 2px solid #f1f1f1;
  border-radius: 0;
  background: transparent;
  color: #f1f1f1;
  font: 500 normal calc(2.3 * var(--vw))/1.6 "Satoshi", sans-serif;
  letter-spacing: -0.03em;
  padding: 0.2em 0;
  outline: none;
  min-width: 200px;
  transition: border-color 0.3s ease;
  text-decoration: none;
  text-align: center;
  appearance: none;
}

.form-input.inline-input::placeholder {
  color: rgba(241, 241, 241, 0.5);
  opacity: 1; /* Firefox fix */
}

.form-input.inline-input:focus {
  border-bottom-color: #CCFF00;
}

/* Remove autofill background */
.form-input.inline-input:-webkit-autofill,
.form-input.inline-input:-webkit-autofill:hover,
.form-input.inline-input:-webkit-autofill:focus,
.form-input.inline-input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px #121212 inset !important;
  -webkit-text-fill-color: #f1f1f1 !important;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

/* Remove autofill background for Firefox */
.form-input.inline-input:-moz-autofill {
  background-color: #121212 !important;
  color: #f1f1f1 !important;
}

.form-heading {
  font: 500 normal calc(2.3 * var(--vw))/1.6 "Satoshi", sans-serif;
  letter-spacing: -0.03em;
  color: #f1f1f1;
  margin-bottom: calc(2 * var(--vw));
}

.form-textarea {
  width: 100%;
  max-width: 900px;
  background: transparent;
  border: 2px solid rgba(241, 241, 241, 0.3);
  border-radius: 0.3em;
  padding: calc(1.5 * var(--vw));
  color: #f1f1f1;
  font: 500 normal calc(2.3 * var(--vw))/1.6 "Satoshi", sans-serif;
  letter-spacing: -0.03em;
  outline: none;
  resize: vertical;
  height: auto;
  min-height: 60px;
  transition: border-color 0.3s ease;
  appearance: none;
}

.form-textarea::placeholder {
  color: rgba(241, 241, 241, 0.5);
  opacity: 1; /* Firefox fix */
}

.form-textarea:focus {
  border-color: #CCFF00;
}

/* Remove autofill background for textarea */
.form-textarea:-webkit-autofill,
.form-textarea:-webkit-autofill:hover,
.form-textarea:-webkit-autofill:focus,
.form-textarea:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px #121212 inset !important;
  -webkit-text-fill-color: #f1f1f1 !important;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

/* Remove autofill background for Firefox textarea */
.form-textarea:-moz-autofill {
  background-color: #121212 !important;
  color: #f1f1f1 !important;
}

.solution-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: calc(1.5 * var(--vw));
  margin-top: calc(1.5 * var(--vw));
}

.solution-button {
  background: transparent;
  border: 2px solid rgba(241, 241, 241, 0.3);
  color: #f1f1f1;
  font: 500 normal calc(1.8 * var(--vw))/1.6 "Satoshi", sans-serif;
  letter-spacing: -0.03em;
  padding: calc(1 * var(--vw)) calc(2.5 * var(--vw));
  border-radius: 0.3em;
  cursor: pointer;
  transition: all 0.3s ease;
  outline: none;
  appearance: none;
}

.solution-button:hover {
  border-color: #f1f1f1;
  background: rgba(241, 241, 241, 0.1);
}

.solution-button.active {
  border-color: #afafaf;
  background: #afafaf;
  color: #ffffff;
}

.form-submit-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: calc(4 * var(--vw));
}

.submit-button {
  background: #CCFF00;
  color: #121212;
  border: none;
  font: 500 normal calc(2 * var(--vw))/1.6 "Satoshi", sans-serif;
  letter-spacing: -0.03em;
  padding: calc(1.2 * var(--vw)) calc(4 * var(--vw));
  border-radius: 0.3em;
  cursor: pointer;
  transition: all 0.3s ease;
  outline: none;
  appearance: none;
}

.submit-button:hover:not(:disabled) {
  background: #afafaf;
  color: #ffffff;
  transform: translateY(-2px);
}

.submit-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.submit-message {
  margin-top: calc(1.5 * var(--vw));
  font: 500 normal calc(1.5 * var(--vw))/1.6 "Satoshi", sans-serif;
  letter-spacing: -0.03em;
}

.submit-message.success {
  color: #CCFF00;
}

.submit-message.error {
  color: #ff6b6b;
}

/* ==================== DESKTOP SPECIFIC STYLES ==================== */

/* Browser-specific fixes */
@supports (-webkit-appearance: none) {
  /* Safari & Chrome specific */
  .form-section {
    -webkit-font-smoothing: antialiased;
  }
  
  .form-slide { /* Force hardware acceleration */
    transform: translateZ(0);
  }
}

@supports (-moz-appearance: none) {
  /* Firefox specific */
  .form-section {
    -moz-font-smoothing: grayscale;
  }
  
  .form-input.inline-input::placeholder,
  .form-textarea::placeholder {
    opacity: 1;
  }
}

/* Small Desktop / Laptop (1025px - 1366px) */
@media (min-width: 1025px) and (max-width: 1366px) {
  .form-slide {
    padding: calc(4.5 * var(--vw)) calc(5 * var(--vw));
  }

  .form-slide-heading-personal {
    padding: calc(4.5 * var(--vw)) calc(5 * var(--vw)) !important;
    gap: calc(3.5 * var(--vw));
  }

  .form-slide-heading-personal .form-heading-banner {
    padding: 55px 28px;
  }

  .heading-line {
    font-size: clamp(40px, calc(5.8 * var(--vw)), 75px);
  }

  .form-slide-heading-personal .heading-line {
    font-size: clamp(40px, calc(5.5 * var(--vw)), 75px);
  }

  .fire-emoji {
    font-size: clamp(40px, calc(5.8 * var(--vw)), 75px);
  }

  .form-text {
    font-size: clamp(18px, calc(2.2 * var(--vw)), 26px);
  }

  .form-input.inline-input {
    font-size: clamp(18px, calc(2.2 * var(--vw)), 26px);
  }

  .form-heading {
    font-size: clamp(18px, calc(2.2 * var(--vw)), 26px);
  }

  .form-textarea {
    font-size: clamp(18px, calc(2.2 * var(--vw)), 26px);
    padding: calc(1.3 * var(--vw));
  }

  .solution-button {
    font-size: clamp(16px, calc(1.7 * var(--vw)), 20px);
    padding: calc(0.9 * var(--vw)) calc(2.3 * var(--vw));
  }

  .submit-button {
    font-size: clamp(18px, calc(2 * var(--vw)), 23px);
    padding: calc(1.1 * var(--vw)) calc(3.8 * var(--vw));
  }
}

/* Medium Desktop (1367px - 1920px) - Standard Desktop */
@media (min-width: 1367px) and (max-width: 1920px) {
  .form-slide {
    padding: calc(5 * var(--vw)) calc(5.5 * var(--vw));
  }

  .form-slide-heading-personal {
    padding: calc(5 * var(--vw)) calc(5.5 * var(--vw)) !important;
    gap: calc(4 * var(--vw));
  }

  .form-slide-heading-personal .form-heading-banner {
    padding: 60.95px 30.475px;
  }

  .heading-line {
    font-size: clamp(45px, calc(6 * var(--vw)), 80px);
  }

  .form-slide-heading-personal .heading-line {
    font-size: clamp(45px, calc(5.5 * var(--vw)), 80px);
  }

  .fire-emoji {
    font-size: clamp(45px, calc(6 * var(--vw)), 80px);
  }

  .form-text {
    font-size: clamp(20px, calc(2.3 * var(--vw)), 28px);
  }

  .form-input.inline-input {
    font-size: clamp(20px, calc(2.3 * var(--vw)), 28px);
  }

  .form-heading {
    font-size: clamp(20px, calc(2.3 * var(--vw)), 28px);
  }

  .form-textarea {
    font-size: clamp(20px, calc(2.3 * var(--vw)), 28px);
    padding: calc(1.5 * var(--vw));
  }

  .solution-button {
    font-size: clamp(17px, calc(1.8 * var(--vw)), 22px);
    padding: calc(1 * var(--vw)) calc(2.5 * var(--vw));
  }

  .submit-button {
    font-size: clamp(19px, calc(2 * var(--vw)), 24px);
    padding: calc(1.2 * var(--vw)) calc(4 * var(--vw));
  }
}

/* Large Desktop (1921px+) */
@media (min-width: 1921px) {
  .form-slide {
    padding: calc(4 * var(--vw)) calc(5 * var(--vw));
    max-width: 1920px;
    margin: 0 auto;
  }

  .form-slide-heading-personal {
    padding: calc(4 * var(--vw)) calc(5 * var(--vw)) !important;
    gap: calc(3.5 * var(--vw));
    max-width: 1920px;
    margin: 0 auto;
  }

  .form-slide-heading-personal .form-heading-banner {
    padding: 65px 35px;
  }

  .heading-line {
    font-size: clamp(50px, calc(5.5 * var(--vw)), 85px);
  }

  .form-slide-heading-personal .heading-line {
    font-size: clamp(50px, calc(5.5 * var(--vw)), 85px);
  }

  .fire-emoji {
    font-size: clamp(50px, calc(5.5 * var(--vw)), 85px);
  }

  .form-text {
    font-size: clamp(22px, calc(2.3 * var(--vw)), 30px);
  }

  .form-input.inline-input {
    font-size: clamp(22px, calc(2.3 * var(--vw)), 30px);
  }

  .form-heading {
    font-size: clamp(22px, calc(2.3 * var(--vw)), 30px);
  }

  .form-textarea {
    font-size: clamp(22px, calc(2.3 * var(--vw)), 30px);
    padding: calc(1.5 * var(--vw));
  }

  .solution-button {
    font-size: clamp(18px, calc(1.8 * var(--vw)), 24px);
    padding: calc(1 * var(--vw)) calc(2.5 * var(--vw));
  }

  .submit-button {
    font-size: clamp(20px, calc(2 * var(--vw)), 26px);
    padding: calc(1.2 * var(--vw)) calc(4 * var(--vw));
  }
}

/* MacBook 13" (1280px - 1440px) */
@media (min-width: 1280px) and (max-width: 1440px) {
  .form-slide-heading-personal .form-heading-banner {
    padding: 58px 29px;
  }

  .heading-line {
    font-size: clamp(42px, calc(5.7 * var(--vw)), 77px);
  }

  .form-slide-heading-personal .heading-line {
    font-size: clamp(42px, calc(5.4 * var(--vw)), 77px);
  }
}

/* MacBook 14" & 16" (1441px - 1728px) */
@media (min-width: 1441px) and (max-width: 1728px) {
  .form-slide-heading-personal .form-heading-banner {
    padding: 62px 31px;
  }

  .heading-line {
    font-size: clamp(47px, calc(5.9 * var(--vw)), 82px);
  }

  .form-slide-heading-personal .heading-line {
    font-size: clamp(47px, calc(5.6 * var(--vw)), 82px);
  }
}

/* Edge & Chrome specific fixes */
@supports (display: grid) {
  .form-slide-heading-personal {
    display: flex;
  }
}

/* Firefox specific text rendering */
@-moz-document url-prefix() {
  .heading-line {
    font-feature-settings: "kern" 1;
    text-rendering: optimizeLegibility;
  }

  .form-text {
    text-rendering: optimizeLegibility;
  }
}

/* Safari specific fixes */
@media screen and (-webkit-min-device-pixel-ratio: 0) {
  .form-slide {
    backface-visibility: hidden;
    perspective: 1000px;
  }

  .form-input.inline-input {
    appearance: none;
    border-radius: 0;
  }

  .form-textarea {
    appearance: none;
    /* border-radius tetap 0.3em dari base style */
  }
}

/* Tablet Responsive (769px - 1024px) */
@media (min-width: 769px) and (max-width: 1024px) {
  .form-slide-heading-personal {
    flex-direction: column;
    gap: calc(4 * var(--vw));
    padding: calc(5 * var(--vw)) calc(5.5 * var(--vw)) !important;
    align-items: flex-start;
  }

  .form-slide-heading-personal .form-heading-banner {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 40px 20px 40px 0;
    min-width: 0;
  }

  .form-slide-heading-personal .form-group {
    flex: 0 0 100%;
    max-width: 100%;
    min-width: 0;
  }
}

/* Mobile Responsive (max-width: 768px) */
@media (max-width: 768px) {
  .form-section {
    padding: 0;
    min-height: 100vh;
    min-height: -webkit-fill-available;
    background: #121212 !important; /* Ensure background stays visible */
  }

  .form-slide {
    padding: calc(8 * var(--vw)) calc(5 * var(--vw));
    min-height: 100vh;
    min-height: -webkit-fill-available;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .form-slide-heading-personal {
    flex-direction: column;
    gap: calc(6 * var(--vw));
    padding: calc(10 * var(--vw)) calc(6 * var(--vw)) !important;
    align-items: flex-start;
    justify-content: center;
    min-height: auto;
    width: 100%;
  }

  .form-slide-heading-personal .form-heading-banner {
    width: 100%;
    max-width: 100%;
    padding: calc(8 * var(--vw)) calc(5 * var(--vw));
  }

  .form-slide-heading-personal .form-group {
    width: 100%;
    max-width: 100%;
  }

  .form-heading-banner {
    padding: calc(8 * var(--vw)) calc(5 * var(--vw));
    margin-bottom: calc(8 * var(--vw));
  }

  .heading-line {
    font: 500 normal calc(24 * var(--vw))/0.9 "Satoshi", sans-serif;
    letter-spacing: -0.05em;
    white-space: normal; /* Allow wrapping on mobile */
  }

  .form-slide-heading-personal .heading-line {
    white-space: normal;
    font-size: calc(12 * var(--vw));
  }

  .fire-emoji {
    font-size: calc(12 * var(--vw));
    line-height: 0.9;
  }

  .form-text {
    font-size: calc(5 * var(--vw));
  }

  .form-input.inline-input {
    font-size: calc(5 * var(--vw));
    min-width: 0;
    display: block;
    width: 100%;
    margin: 0.5em 0;
    text-align: left;
  }

  .form-heading {
    font-size: calc(6 * var(--vw));
    margin-bottom: calc(3 * var(--vw));
  }

  .form-textarea {
    font-size: calc(5.5 * var(--vw));
    padding: calc(5 * var(--vw));
    min-height: 120px;
  }

  .solution-button {
    font-size: calc(4.5 * var(--vw));
    padding: calc(3 * var(--vw)) calc(5 * var(--vw));
    width: 100%;
  }

  .submit-button {
    font-size: calc(5 * var(--vw));
    padding: calc(3.5 * var(--vw)) calc(7 * var(--vw));
    width: 100%;
    max-width: 100%;
  }

  .submit-message {
    font-size: calc(4 * var(--vw));
    text-align: center;
    margin-top: calc(2.5 * var(--vw));
  }
}

/* Small Mobile (max-width: 480px) */
@media (max-width: 480px) {
  .form-section {
    background: #121212 !important; /* Ensure background stays visible */
  }

  .form-slide {
    padding: calc(6 * var(--vw)) calc(4 * var(--vw));
  }

  .form-slide-heading-personal {
    padding: calc(8 * var(--vw)) calc(5 * var(--vw)) !important;
    gap: calc(5 * var(--vw));
    justify-content: center;
    min-height: 100vh;
    min-height: -webkit-fill-available;
  }

  .form-slide-heading-personal .form-heading-banner {
    padding: calc(7 * var(--vw)) calc(4 * var(--vw));
  }

  .heading-line {
    font-size: calc(11 * var(--vw));
  }

  .form-slide-heading-personal .heading-line {
    font-size: calc(11 * var(--vw));
  }

  .fire-emoji {
    font-size: calc(11 * var(--vw));
  }

  .form-text {
    font-size: calc(4.5 * var(--vw));
  }

  .form-input.inline-input {
    font-size: calc(4.5 * var(--vw));
  }

  .form-heading {
    font-size: calc(5.5 * var(--vw));
    margin-bottom: calc(2.5 * var(--vw));
  }

  .form-textarea {
    font-size: calc(5 * var(--vw));
    padding: calc(4.5 * var(--vw));
    min-height: 130px;
  }

  .solution-button {
    font-size: calc(4 * var(--vw));
    padding: calc(2.5 * var(--vw)) calc(4.5 * var(--vw));
  }

  .submit-button {
    font-size: calc(4.5 * var(--vw));
    padding: calc(3 * var(--vw)) calc(6 * var(--vw));
  }

  .submit-message {
    font-size: calc(3.5 * var(--vw));
    margin-top: calc(2 * var(--vw));
  }
}

`, "",{"version":3,"sources":["webpack://./src/component/form/form.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,iBAAiB;EACjB,kCAAkC,EAAE,4BAA4B;EAChE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;EACtB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,8DAA8D;EAC9D,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,8BAA8B,EAAE,4BAA4B;EAC5D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gCAAgC;EAChC,kDAAkD;EAClD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,6DAA6D;EAC7D,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,kCAAkC;EAClC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA,uCAAuC;AACvC;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gEAAgE;EAChE,uBAAuB;EACvB,cAAc;EACd,oCAAoC;EACpC,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gEAAgE;EAChE,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,kCAAkC;EAClC,qBAAqB;EACrB,kBAAkB;EAGlB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,UAAU,EAAE,gBAAgB;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,+BAA+B;AAC/B;;;;EAIE,uDAAuD;EACvD,2CAA2C;EAC3C,yDAAiD;EAAjD,iDAAiD;AACnD;;AAEA,2CAA2C;AAC3C;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,gEAAgE;EAChE,uBAAuB;EACvB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,0CAA0C;EAC1C,oBAAoB;EACpB,8BAA8B;EAC9B,cAAc;EACd,gEAAgE;EAChE,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAGlC,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,UAAU,EAAE,gBAAgB;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,4CAA4C;AAC5C;;;;EAIE,uDAAuD;EACvD,2CAA2C;EAC3C,yDAAiD;EAAjD,iDAAiD;AACnD;;AAEA,oDAAoD;AACpD;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,cAAc;EACd,gEAAgE;EAChE,uBAAuB;EACvB,kDAAkD;EAClD,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,aAAa;EAGb,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,8DAA8D;EAC9D,uBAAuB;EACvB,kDAAkD;EAClD,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,aAAa;EAGb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,gEAAgE;EAChE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,sEAAsE;;AAEtE,2BAA2B;AAC3B;EACE,6BAA6B;EAC7B;IACE,mCAAmC;EACrC;;EAEA,cACoC,gCAAgC;IAClE,wBAAwB;EAC1B;AACF;;AAEA;EACE,qBAAqB;EACrB;IACE,8BAA8B;EAChC;;EAEA;;IAEE,UAAU;EACZ;AACF;;AAEA,6CAA6C;AAC7C;EACE;IACE,kDAAkD;EACpD;;EAEA;IACE,6DAA6D;IAC7D,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mDAAmD;EACrD;;EAEA;IACE,mDAAmD;EACrD;;EAEA;IACE,mDAAmD;EACrD;;EAEA;IACE,mDAAmD;EACrD;;EAEA;IACE,mDAAmD;EACrD;;EAEA;IACE,mDAAmD;EACrD;;EAEA;IACE,mDAAmD;IACnD,8BAA8B;EAChC;;EAEA;IACE,mDAAmD;IACnD,oDAAoD;EACtD;;EAEA;IACE,iDAAiD;IACjD,oDAAoD;EACtD;AACF;;AAEA,wDAAwD;AACxD;EACE;IACE,kDAAkD;EACpD;;EAEA;IACE,6DAA6D;IAC7D,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iDAAiD;EACnD;;EAEA;IACE,mDAAmD;EACrD;;EAEA;IACE,iDAAiD;EACnD;;EAEA;IACE,mDAAmD;EACrD;;EAEA;IACE,mDAAmD;EACrD;;EAEA;IACE,mDAAmD;EACrD;;EAEA;IACE,mDAAmD;IACnD,8BAA8B;EAChC;;EAEA;IACE,mDAAmD;IACnD,kDAAkD;EACpD;;EAEA;IACE,iDAAiD;IACjD,kDAAkD;EACpD;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,gDAAgD;IAChD,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,2DAA2D;IAC3D,0BAA0B;IAC1B,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mDAAmD;EACrD;;EAEA;IACE,mDAAmD;EACrD;;EAEA;IACE,mDAAmD;EACrD;;EAEA;IACE,mDAAmD;EACrD;;EAEA;IACE,mDAAmD;EACrD;;EAEA;IACE,mDAAmD;EACrD;;EAEA;IACE,mDAAmD;IACnD,8BAA8B;EAChC;;EAEA;IACE,mDAAmD;IACnD,kDAAkD;EACpD;;EAEA;IACE,iDAAiD;IACjD,kDAAkD;EACpD;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mDAAmD;EACrD;;EAEA;IACE,mDAAmD;EACrD;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mDAAmD;EACrD;;EAEA;IACE,mDAAmD;EACrD;AACF;;AAEA,iCAAiC;AACjC;EACE;IAGE,aAAa;EACf;AACF;;AAEA,oCAAoC;AACpC;EACE;IAEE,+BAA+B;IAC/B,kCAAkC;EACpC;;EAEA;IACE,kCAAkC;EACpC;AACF;;AAEA,0BAA0B;AAC1B;EACE;IAEE,2BAA2B;IAE3B,mBAAmB;EACrB;;EAEA;IAEE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IAEE,gBAAgB;IAChB,8CAA8C;EAChD;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,sBAAsB;IACtB,wBAAwB;IACxB,6DAA6D;IAC7D,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,eAAe;IACf,YAAY;EACd;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,UAAU;IACV,iBAAiB;IACjB,kCAAkC;IAClC,8BAA8B,EAAE,oCAAoC;EACtE;;EAEA;IACE,gDAAgD;IAChD,iBAAiB;IACjB,kCAAkC;IAClC,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,wBAAwB;IACxB,4DAA4D;IAC5D,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gDAAgD;EAClD;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,gDAAgD;IAChD,kCAAkC;EACpC;;EAEA;IACE,+DAA+D;IAC/D,uBAAuB;IACvB,mBAAmB,EAAE,6BAA6B;EACpD;;EAEA;IACE,mBAAmB;IACnB,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;IAC/B,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,YAAY;IACZ,cAAc;IACd,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;IAC9B,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;IAChC,4BAA4B;IAC5B,iBAAiB;EACnB;;EAEA;IACE,gCAAgC;IAChC,gDAAgD;IAChD,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,kDAAkD;IAClD,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,8BAA8B;IAC9B,kBAAkB;IAClB,iCAAiC;EACnC;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,8BAA8B,EAAE,oCAAoC;EACtE;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,2DAA2D;IAC3D,wBAAwB;IACxB,uBAAuB;IACvB,iBAAiB;IACjB,kCAAkC;EACpC;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;IAChC,oCAAoC;EACtC;;EAEA;IACE,8BAA8B;IAC9B,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;IAC9B,oDAAoD;EACtD;;EAEA;IACE,gCAAgC;IAChC,gDAAgD;EAClD;;EAEA;IACE,gCAAgC;IAChC,+BAA+B;EACjC;AACF","sourcesContent":[".form-section {\n  background: #121212;\n  color: #f1f1f1;\n  padding: 0;\n  min-height: 100vh;\n  min-height: -webkit-fill-available; /* Fix untuk mobile Safari */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  /* width: 100%; */\n  max-width: calc(100 * var(--vw));\n  overflow-x: hidden;\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.form-heading-banner {\n  width: 100%;\n  max-width: 100%;\n  padding: 60.95px 30.475px;\n  margin-bottom: 0;\n  display: flex;\n  align-items: flex-start;\n}\n\n.heading-content {\n  display: flex;\n  flex-direction: column;\n  gap: calc(0.5 * var(--vw));\n  width: 100%;\n  overflow: visible;\n}\n\n.heading-line {\n  font: 500 normal calc(6 * var(--vw))/0.9 \"Satoshi\", sans-serif;\n  letter-spacing: -0.05em;\n  color: #f1f1f1;\n  display: flex;\n  align-items: center;\n  gap: calc(0.5 * var(--vw));\n  white-space: nowrap;\n  overflow: visible;\n  width: 100%;\n}\n\n.form-slide-heading-personal .heading-line {\n  font-size: clamp(32px, calc(5.5 * var(--vw)), 80px);\n}\n\n.fire-emoji {\n  font-size: calc(6 * var(--vw));\n  line-height: 0.9;\n  display: inline-block;\n}\n\n.contact-form {\n  max-width: 900px;\n  width: 100%;\n}\n\n/* Form Slide Styles - Slide by Slide Animation */\n.form-slide {\n  height: 100vh;\n  height: -webkit-fill-available; /* Fix untuk mobile Safari */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  max-width: calc(100 * var(--vw));\n  padding: calc(5 * var(--vw)) calc(5.5 * var(--vw));\n  box-sizing: border-box;\n}\n\n.form-slide-heading-personal {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: calc(4 * var(--vw));\n  padding: calc(5 * var(--vw)) calc(5.5 * var(--vw)) !important;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.form-slide-heading-personal .form-heading-banner {\n  margin-bottom: 0 !important;\n  width: 100%;\n  max-width: 100%;\n  padding: 60.95px 30.475px;\n  margin-left: 0 !important;\n  padding-left: 0 !important;\n  box-sizing: border-box;\n  overflow: visible;\n}\n\n.form-slide-heading-personal .form-heading-banner .heading-content {\n  width: 100%;\n  overflow: visible;\n  padding: 0;\n  margin: 0;\n}\n\n.form-slide-heading-personal .heading-line {\n  padding: 0;\n  margin: 0;\n}\n\n.form-slide-heading-personal .form-group {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 0;\n  box-sizing: border-box;\n}\n\n.form-slide-heading-personal .form-group .form-text {\n  max-width: 100%;\n}\n\n.form-slide-project-solution-submit {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.form-slide-personal .form-group,\n.form-slide-project-solution-submit .form-group {\n  margin-bottom: calc(4 * var(--vw));\n  width: 100%;\n  max-width: 900px;\n}\n\n.form-slide-project-solution-submit {\n  flex-direction: column;\n  gap: calc(2 * var(--vw));\n}\n\n/* Responsive adjustments for slide 2 */\n@media (max-width: 768px) {\n  .form-slide-project-solution-submit {\n    gap: calc(4 * var(--vw));\n  }\n\n  .form-slide-project-solution-submit .form-group {\n    margin-bottom: calc(5 * var(--vw));\n  }\n}\n\n@media (max-width: 480px) {\n  .form-slide-project-solution-submit {\n    gap: calc(3.5 * var(--vw));\n  }\n\n  .form-slide-project-solution-submit .form-group {\n    margin-bottom: calc(4 * var(--vw));\n  }\n}\n\n.form-slide-project-solution-submit .form-submit-container {\n  margin-top: 0;\n}\n\n.form-group {\n  margin-bottom: calc(4 * var(--vw));\n  width: 100%;\n}\n\n.form-slide-heading-personal .form-group {\n  margin-bottom: 0;\n}\n\n.form-text {\n  font: 500 normal calc(2.3 * var(--vw))/1.6 \"Satoshi\", sans-serif;\n  letter-spacing: -0.03em;\n  color: #f1f1f1;\n  margin-bottom: calc(1.5 * var(--vw));\n  max-width: 100%;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n.form-slide-heading-personal .form-text {\n  max-width: 100%;\n  line-height: 1.5;\n  word-spacing: 0.05em;\n}\n\n.form-input.inline-input {\n  border: none;\n  border-bottom: 2px solid #f1f1f1;\n  border-radius: 0;\n  background: transparent;\n  color: #f1f1f1;\n  font: 500 normal calc(2.3 * var(--vw))/1.6 \"Satoshi\", sans-serif;\n  letter-spacing: -0.03em;\n  padding: 0.2em 0;\n  outline: none;\n  min-width: 200px;\n  transition: border-color 0.3s ease;\n  text-decoration: none;\n  text-align: center;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\n.form-input.inline-input::placeholder {\n  color: rgba(241, 241, 241, 0.5);\n  opacity: 1; /* Firefox fix */\n}\n\n.form-input.inline-input:focus {\n  border-bottom-color: #CCFF00;\n}\n\n/* Remove autofill background */\n.form-input.inline-input:-webkit-autofill,\n.form-input.inline-input:-webkit-autofill:hover,\n.form-input.inline-input:-webkit-autofill:focus,\n.form-input.inline-input:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px #121212 inset !important;\n  -webkit-text-fill-color: #f1f1f1 !important;\n  transition: background-color 5000s ease-in-out 0s;\n}\n\n/* Remove autofill background for Firefox */\n.form-input.inline-input:-moz-autofill {\n  background-color: #121212 !important;\n  color: #f1f1f1 !important;\n}\n\n.form-heading {\n  font: 500 normal calc(2.3 * var(--vw))/1.6 \"Satoshi\", sans-serif;\n  letter-spacing: -0.03em;\n  color: #f1f1f1;\n  margin-bottom: calc(2 * var(--vw));\n}\n\n.form-textarea {\n  width: 100%;\n  max-width: 900px;\n  background: transparent;\n  border: 2px solid rgba(241, 241, 241, 0.3);\n  border-radius: 0.3em;\n  padding: calc(1.5 * var(--vw));\n  color: #f1f1f1;\n  font: 500 normal calc(2.3 * var(--vw))/1.6 \"Satoshi\", sans-serif;\n  letter-spacing: -0.03em;\n  outline: none;\n  resize: vertical;\n  height: auto;\n  min-height: 60px;\n  transition: border-color 0.3s ease;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\n.form-textarea::placeholder {\n  color: rgba(241, 241, 241, 0.5);\n  opacity: 1; /* Firefox fix */\n}\n\n.form-textarea:focus {\n  border-color: #CCFF00;\n}\n\n/* Remove autofill background for textarea */\n.form-textarea:-webkit-autofill,\n.form-textarea:-webkit-autofill:hover,\n.form-textarea:-webkit-autofill:focus,\n.form-textarea:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px #121212 inset !important;\n  -webkit-text-fill-color: #f1f1f1 !important;\n  transition: background-color 5000s ease-in-out 0s;\n}\n\n/* Remove autofill background for Firefox textarea */\n.form-textarea:-moz-autofill {\n  background-color: #121212 !important;\n  color: #f1f1f1 !important;\n}\n\n.solution-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: calc(1.5 * var(--vw));\n  margin-top: calc(1.5 * var(--vw));\n}\n\n.solution-button {\n  background: transparent;\n  border: 2px solid rgba(241, 241, 241, 0.3);\n  color: #f1f1f1;\n  font: 500 normal calc(1.8 * var(--vw))/1.6 \"Satoshi\", sans-serif;\n  letter-spacing: -0.03em;\n  padding: calc(1 * var(--vw)) calc(2.5 * var(--vw));\n  border-radius: 0.3em;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\n.solution-button:hover {\n  border-color: #f1f1f1;\n  background: rgba(241, 241, 241, 0.1);\n}\n\n.solution-button.active {\n  border-color: #afafaf;\n  background: #afafaf;\n  color: #ffffff;\n}\n\n.form-submit-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: calc(4 * var(--vw));\n}\n\n.submit-button {\n  background: #CCFF00;\n  color: #121212;\n  border: none;\n  font: 500 normal calc(2 * var(--vw))/1.6 \"Satoshi\", sans-serif;\n  letter-spacing: -0.03em;\n  padding: calc(1.2 * var(--vw)) calc(4 * var(--vw));\n  border-radius: 0.3em;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\n.submit-button:hover:not(:disabled) {\n  background: #afafaf;\n  color: #ffffff;\n  transform: translateY(-2px);\n}\n\n.submit-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.submit-message {\n  margin-top: calc(1.5 * var(--vw));\n  font: 500 normal calc(1.5 * var(--vw))/1.6 \"Satoshi\", sans-serif;\n  letter-spacing: -0.03em;\n}\n\n.submit-message.success {\n  color: #CCFF00;\n}\n\n.submit-message.error {\n  color: #ff6b6b;\n}\n\n/* ==================== DESKTOP SPECIFIC STYLES ==================== */\n\n/* Browser-specific fixes */\n@supports (-webkit-appearance: none) {\n  /* Safari & Chrome specific */\n  .form-section {\n    -webkit-font-smoothing: antialiased;\n  }\n  \n  .form-slide {\n    -webkit-transform: translateZ(0); /* Force hardware acceleration */\n    transform: translateZ(0);\n  }\n}\n\n@supports (-moz-appearance: none) {\n  /* Firefox specific */\n  .form-section {\n    -moz-font-smoothing: grayscale;\n  }\n  \n  .form-input.inline-input::placeholder,\n  .form-textarea::placeholder {\n    opacity: 1;\n  }\n}\n\n/* Small Desktop / Laptop (1025px - 1366px) */\n@media (min-width: 1025px) and (max-width: 1366px) {\n  .form-slide {\n    padding: calc(4.5 * var(--vw)) calc(5 * var(--vw));\n  }\n\n  .form-slide-heading-personal {\n    padding: calc(4.5 * var(--vw)) calc(5 * var(--vw)) !important;\n    gap: calc(3.5 * var(--vw));\n  }\n\n  .form-slide-heading-personal .form-heading-banner {\n    padding: 55px 28px;\n  }\n\n  .heading-line {\n    font-size: clamp(40px, calc(5.8 * var(--vw)), 75px);\n  }\n\n  .form-slide-heading-personal .heading-line {\n    font-size: clamp(40px, calc(5.5 * var(--vw)), 75px);\n  }\n\n  .fire-emoji {\n    font-size: clamp(40px, calc(5.8 * var(--vw)), 75px);\n  }\n\n  .form-text {\n    font-size: clamp(18px, calc(2.2 * var(--vw)), 26px);\n  }\n\n  .form-input.inline-input {\n    font-size: clamp(18px, calc(2.2 * var(--vw)), 26px);\n  }\n\n  .form-heading {\n    font-size: clamp(18px, calc(2.2 * var(--vw)), 26px);\n  }\n\n  .form-textarea {\n    font-size: clamp(18px, calc(2.2 * var(--vw)), 26px);\n    padding: calc(1.3 * var(--vw));\n  }\n\n  .solution-button {\n    font-size: clamp(16px, calc(1.7 * var(--vw)), 20px);\n    padding: calc(0.9 * var(--vw)) calc(2.3 * var(--vw));\n  }\n\n  .submit-button {\n    font-size: clamp(18px, calc(2 * var(--vw)), 23px);\n    padding: calc(1.1 * var(--vw)) calc(3.8 * var(--vw));\n  }\n}\n\n/* Medium Desktop (1367px - 1920px) - Standard Desktop */\n@media (min-width: 1367px) and (max-width: 1920px) {\n  .form-slide {\n    padding: calc(5 * var(--vw)) calc(5.5 * var(--vw));\n  }\n\n  .form-slide-heading-personal {\n    padding: calc(5 * var(--vw)) calc(5.5 * var(--vw)) !important;\n    gap: calc(4 * var(--vw));\n  }\n\n  .form-slide-heading-personal .form-heading-banner {\n    padding: 60.95px 30.475px;\n  }\n\n  .heading-line {\n    font-size: clamp(45px, calc(6 * var(--vw)), 80px);\n  }\n\n  .form-slide-heading-personal .heading-line {\n    font-size: clamp(45px, calc(5.5 * var(--vw)), 80px);\n  }\n\n  .fire-emoji {\n    font-size: clamp(45px, calc(6 * var(--vw)), 80px);\n  }\n\n  .form-text {\n    font-size: clamp(20px, calc(2.3 * var(--vw)), 28px);\n  }\n\n  .form-input.inline-input {\n    font-size: clamp(20px, calc(2.3 * var(--vw)), 28px);\n  }\n\n  .form-heading {\n    font-size: clamp(20px, calc(2.3 * var(--vw)), 28px);\n  }\n\n  .form-textarea {\n    font-size: clamp(20px, calc(2.3 * var(--vw)), 28px);\n    padding: calc(1.5 * var(--vw));\n  }\n\n  .solution-button {\n    font-size: clamp(17px, calc(1.8 * var(--vw)), 22px);\n    padding: calc(1 * var(--vw)) calc(2.5 * var(--vw));\n  }\n\n  .submit-button {\n    font-size: clamp(19px, calc(2 * var(--vw)), 24px);\n    padding: calc(1.2 * var(--vw)) calc(4 * var(--vw));\n  }\n}\n\n/* Large Desktop (1921px+) */\n@media (min-width: 1921px) {\n  .form-slide {\n    padding: calc(4 * var(--vw)) calc(5 * var(--vw));\n    max-width: 1920px;\n    margin: 0 auto;\n  }\n\n  .form-slide-heading-personal {\n    padding: calc(4 * var(--vw)) calc(5 * var(--vw)) !important;\n    gap: calc(3.5 * var(--vw));\n    max-width: 1920px;\n    margin: 0 auto;\n  }\n\n  .form-slide-heading-personal .form-heading-banner {\n    padding: 65px 35px;\n  }\n\n  .heading-line {\n    font-size: clamp(50px, calc(5.5 * var(--vw)), 85px);\n  }\n\n  .form-slide-heading-personal .heading-line {\n    font-size: clamp(50px, calc(5.5 * var(--vw)), 85px);\n  }\n\n  .fire-emoji {\n    font-size: clamp(50px, calc(5.5 * var(--vw)), 85px);\n  }\n\n  .form-text {\n    font-size: clamp(22px, calc(2.3 * var(--vw)), 30px);\n  }\n\n  .form-input.inline-input {\n    font-size: clamp(22px, calc(2.3 * var(--vw)), 30px);\n  }\n\n  .form-heading {\n    font-size: clamp(22px, calc(2.3 * var(--vw)), 30px);\n  }\n\n  .form-textarea {\n    font-size: clamp(22px, calc(2.3 * var(--vw)), 30px);\n    padding: calc(1.5 * var(--vw));\n  }\n\n  .solution-button {\n    font-size: clamp(18px, calc(1.8 * var(--vw)), 24px);\n    padding: calc(1 * var(--vw)) calc(2.5 * var(--vw));\n  }\n\n  .submit-button {\n    font-size: clamp(20px, calc(2 * var(--vw)), 26px);\n    padding: calc(1.2 * var(--vw)) calc(4 * var(--vw));\n  }\n}\n\n/* MacBook 13\" (1280px - 1440px) */\n@media (min-width: 1280px) and (max-width: 1440px) {\n  .form-slide-heading-personal .form-heading-banner {\n    padding: 58px 29px;\n  }\n\n  .heading-line {\n    font-size: clamp(42px, calc(5.7 * var(--vw)), 77px);\n  }\n\n  .form-slide-heading-personal .heading-line {\n    font-size: clamp(42px, calc(5.4 * var(--vw)), 77px);\n  }\n}\n\n/* MacBook 14\" & 16\" (1441px - 1728px) */\n@media (min-width: 1441px) and (max-width: 1728px) {\n  .form-slide-heading-personal .form-heading-banner {\n    padding: 62px 31px;\n  }\n\n  .heading-line {\n    font-size: clamp(47px, calc(5.9 * var(--vw)), 82px);\n  }\n\n  .form-slide-heading-personal .heading-line {\n    font-size: clamp(47px, calc(5.6 * var(--vw)), 82px);\n  }\n}\n\n/* Edge & Chrome specific fixes */\n@supports (display: grid) {\n  .form-slide-heading-personal {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n  }\n}\n\n/* Firefox specific text rendering */\n@-moz-document url-prefix() {\n  .heading-line {\n    -moz-font-feature-settings: \"kern\" 1;\n    font-feature-settings: \"kern\" 1;\n    text-rendering: optimizeLegibility;\n  }\n\n  .form-text {\n    text-rendering: optimizeLegibility;\n  }\n}\n\n/* Safari specific fixes */\n@media screen and (-webkit-min-device-pixel-ratio: 0) {\n  .form-slide {\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    -webkit-perspective: 1000px;\n    perspective: 1000px;\n  }\n\n  .form-input.inline-input {\n    -webkit-appearance: none;\n    appearance: none;\n    border-radius: 0;\n  }\n\n  .form-textarea {\n    -webkit-appearance: none;\n    appearance: none;\n    /* border-radius tetap 0.3em dari base style */\n  }\n}\n\n/* Tablet Responsive (769px - 1024px) */\n@media (min-width: 769px) and (max-width: 1024px) {\n  .form-slide-heading-personal {\n    flex-direction: column;\n    gap: calc(4 * var(--vw));\n    padding: calc(5 * var(--vw)) calc(5.5 * var(--vw)) !important;\n    align-items: flex-start;\n  }\n\n  .form-slide-heading-personal .form-heading-banner {\n    flex: 0 0 100%;\n    max-width: 100%;\n    padding: 40px 20px 40px 0;\n    min-width: 0;\n  }\n\n  .form-slide-heading-personal .form-group {\n    flex: 0 0 100%;\n    max-width: 100%;\n    min-width: 0;\n  }\n}\n\n/* Mobile Responsive (max-width: 768px) */\n@media (max-width: 768px) {\n  .form-section {\n    padding: 0;\n    min-height: 100vh;\n    min-height: -webkit-fill-available;\n    background: #121212 !important; /* Ensure background stays visible */\n  }\n\n  .form-slide {\n    padding: calc(8 * var(--vw)) calc(5 * var(--vw));\n    min-height: 100vh;\n    min-height: -webkit-fill-available;\n    height: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .form-slide-heading-personal {\n    flex-direction: column;\n    gap: calc(6 * var(--vw));\n    padding: calc(10 * var(--vw)) calc(6 * var(--vw)) !important;\n    align-items: flex-start;\n    justify-content: center;\n    min-height: auto;\n    width: 100%;\n  }\n\n  .form-slide-heading-personal .form-heading-banner {\n    width: 100%;\n    max-width: 100%;\n    padding: calc(8 * var(--vw)) calc(5 * var(--vw));\n  }\n\n  .form-slide-heading-personal .form-group {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .form-heading-banner {\n    padding: calc(8 * var(--vw)) calc(5 * var(--vw));\n    margin-bottom: calc(8 * var(--vw));\n  }\n\n  .heading-line {\n    font: 500 normal calc(24 * var(--vw))/0.9 \"Satoshi\", sans-serif;\n    letter-spacing: -0.05em;\n    white-space: normal; /* Allow wrapping on mobile */\n  }\n\n  .form-slide-heading-personal .heading-line {\n    white-space: normal;\n    font-size: calc(12 * var(--vw));\n  }\n\n  .fire-emoji {\n    font-size: calc(12 * var(--vw));\n    line-height: 0.9;\n  }\n\n  .form-text {\n    font-size: calc(5 * var(--vw));\n  }\n\n  .form-input.inline-input {\n    font-size: calc(5 * var(--vw));\n    min-width: 0;\n    display: block;\n    width: 100%;\n    margin: 0.5em 0;\n    text-align: left;\n  }\n\n  .form-heading {\n    font-size: calc(6 * var(--vw));\n    margin-bottom: calc(3 * var(--vw));\n  }\n\n  .form-textarea {\n    font-size: calc(5.5 * var(--vw));\n    padding: calc(5 * var(--vw));\n    min-height: 120px;\n  }\n\n  .solution-button {\n    font-size: calc(4.5 * var(--vw));\n    padding: calc(3 * var(--vw)) calc(5 * var(--vw));\n    width: 100%;\n  }\n\n  .submit-button {\n    font-size: calc(5 * var(--vw));\n    padding: calc(3.5 * var(--vw)) calc(7 * var(--vw));\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .submit-message {\n    font-size: calc(4 * var(--vw));\n    text-align: center;\n    margin-top: calc(2.5 * var(--vw));\n  }\n}\n\n/* Small Mobile (max-width: 480px) */\n@media (max-width: 480px) {\n  .form-section {\n    background: #121212 !important; /* Ensure background stays visible */\n  }\n\n  .form-slide {\n    padding: calc(6 * var(--vw)) calc(4 * var(--vw));\n  }\n\n  .form-slide-heading-personal {\n    padding: calc(8 * var(--vw)) calc(5 * var(--vw)) !important;\n    gap: calc(5 * var(--vw));\n    justify-content: center;\n    min-height: 100vh;\n    min-height: -webkit-fill-available;\n  }\n\n  .form-slide-heading-personal .form-heading-banner {\n    padding: calc(7 * var(--vw)) calc(4 * var(--vw));\n  }\n\n  .heading-line {\n    font-size: calc(11 * var(--vw));\n  }\n\n  .form-slide-heading-personal .heading-line {\n    font-size: calc(11 * var(--vw));\n  }\n\n  .fire-emoji {\n    font-size: calc(11 * var(--vw));\n  }\n\n  .form-text {\n    font-size: calc(4.5 * var(--vw));\n  }\n\n  .form-input.inline-input {\n    font-size: calc(4.5 * var(--vw));\n  }\n\n  .form-heading {\n    font-size: calc(5.5 * var(--vw));\n    margin-bottom: calc(2.5 * var(--vw));\n  }\n\n  .form-textarea {\n    font-size: calc(5 * var(--vw));\n    padding: calc(4.5 * var(--vw));\n    min-height: 130px;\n  }\n\n  .solution-button {\n    font-size: calc(4 * var(--vw));\n    padding: calc(2.5 * var(--vw)) calc(4.5 * var(--vw));\n  }\n\n  .submit-button {\n    font-size: calc(4.5 * var(--vw));\n    padding: calc(3 * var(--vw)) calc(6 * var(--vw));\n  }\n\n  .submit-message {\n    font-size: calc(3.5 * var(--vw));\n    margin-top: calc(2 * var(--vw));\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
